import { render, staticRenderFns } from "./RightOrWrongIcon.vue?vue&type=template&id=00a184b4&scoped=true&"
import script from "./RightOrWrongIcon.vue?vue&type=script&lang=js&"
export * from "./RightOrWrongIcon.vue?vue&type=script&lang=js&"
import style0 from "./RightOrWrongIcon.vue?vue&type=style&index=0&id=00a184b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a184b4",
  null
  
)

export default component.exports